import { Component, ChangeDetectionStrategy, Type } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldSelectProps } from '@ngx-formly/core/select';
import { BaseFormlyFieldProps } from '../form-field/public_api';

interface AutocompleteProps extends BaseFormlyFieldProps, FormlyFieldSelectProps { }

export interface FormlyAutocompleteFieldConfig extends FormlyFieldConfig<AutocompleteProps> {
    type: 'kendo-autocomplete' | Type<FormlyFieldAutocomplete>;
}

@Component({
    selector: 'formly-field-kendo-autocomplete',
    template: `
        <kendo-autocomplete
              [formControl]="formControl"
              [formlyAttributes]="field"
              [data]="props.options | formlySelectOptions: field | async"
              [valueField]="valueField">
        </kendo-autocomplete>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldAutocomplete extends FieldType<FieldTypeConfig<AutocompleteProps>> {
    get valueField() {
        const value = this.props.valueProp as string;
        return value ?? 'value';
    }
}
